import { put, call } from 'redux-saga/effects';
import { createQadraSaga } from './shared';
import { apiPortfoliosGet } from '../api/portfolio';
import { PORTFOLIOS_GET } from '../actions/types';

export function* portfoliosGet() {
  const { portfolios } = yield call(apiPortfoliosGet);
  yield put({
    type: PORTFOLIOS_GET._SUCCESS,
    payload: { portfolios },
  });
}

const watchPortfoliosGet = createQadraSaga(portfoliosGet, {
  action: PORTFOLIOS_GET._REQUEST,
});

export default [watchPortfoliosGet];
